import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'; 

import { UrlService } from '@core/services/url/url.service';
import { Form } from '@core/objects/form';
import { FieldDataInterface } from '@core/custom-forms/models/settings/settings-custom-form-field-data.model';


@Injectable({
    providedIn: 'root'
})
export class SettingsCustomFormsRequests {

    private readonly prefix = "/settings/custom-forms";


    constructor(private http: HttpClient, private urlSrv : UrlService) {}

    public loadForms$ = (): Observable<Form[]> =>
        this.http.get<Form[]>(this.urlSrv.build(this.prefix));

    public loadForm$ = (id: string): Observable<Form> =>
        this.http.get<Form>(this.urlSrv.build(this.prefix + "/" + id));
      

    public loadFields$ = (id: string): Observable<FieldDataInterface[]> =>
        this.http.get<FieldDataInterface[]>(this.urlSrv.build(this.prefix + "/" +id+ "/fields"));

      // saves
    public createForm$ = (form: Form) : Observable<Form> =>
        this.http.post<Form>(this.urlSrv.build(this.prefix), 
                            {name: form.name, description: form.description }, 
                            { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

    public updateForm$ = (form: Form) : Observable<Form> =>
        this.http.put<Form>(
            this.urlSrv.build(this.prefix + "/" + form.id), 
            {name: form.name, description: form.description }, 
            { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) }
        );
      
    public createFields$ = (formId: string, fields: FieldDataInterface[]) : Observable<FieldDataInterface[]> =>
        this.http.post<FieldDataInterface[]>(
            this.urlSrv.build(this.prefix + "/" + formId + "/fields"), 
            {fields: fields}, 
            { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) }
        );

    public updateFields$ = (formId: string, fields: FieldDataInterface[]) : Observable<FieldDataInterface[]> =>
        this.http.put<FieldDataInterface[]>(
            this.urlSrv.build(this.prefix + "/" + formId + "/fields"), 
            {fields: fields}, 
            { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) }
        );

    public setActiveForm$ = (formId: string, active: boolean): Observable<Form> => {
        return this.http.put<Form>(this.urlSrv.build(this.prefix + "/" + formId), 
            { active: active },
            { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });
        }
    
}